import React from "react"
import { useServicePalette } from "../../hooks/useServicePalette"

interface OrderCardSkeletonProps {
    palette: ReturnType<typeof useServicePalette>;
}

export const OrderCardSkeleton: React.FC<OrderCardSkeletonProps> = ({ palette }) => {
    return (
        <div className={`backdrop-blur-sm rounded-2xl shadow-lg transition-all duration-300 bg-white/80 dark:bg-gray-800/80 ${palette.borderAccent} overflow-hidden animate-pulse`}>
            <div className="p-4">
                <div className="flex justify-between items-start mb-3">
                    <div className="flex-1">
                        <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded w-32 mb-2"></div>
                        <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-48"></div>
                    </div>
                    <div className="flex flex-col items-end gap-2">
                        <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded-full w-32"></div>
                    </div>
                </div>

                <div className="space-y-2">
                    <div className={`flex justify-between items-center rounded-lg p-3 ${palette.bgLight} dark:bg-gray-900/20`}>
                        <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-24"></div>
                        <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-16"></div>
                    </div>
                    <div className={`flex justify-between items-center rounded-lg p-3 ${palette.bgLight} dark:bg-gray-900/20`}>
                        <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-32"></div>
                        <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-16"></div>
                    </div>
                </div>
            </div>
        </div>
    );
};
